'use client';
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useIsUserLoggedIn, useIsUserLoggedInLoading } from '#pplx/frontend/auth/userHooks.js';
import { sanitizeUrl } from '#pplx/frontend/common/files/urls.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useCallback, useMemo } from 'react';
const LoginModal = Dynamic(async () => {
    const { LoginModal } = await import('#pplx/frontend/apps/ask/auth/login/LoginModal.js');
    return { default: LoginModal };
});
export const useBrandedVisitorGate = ({ enabled, }) => {
    const { openModal } = useModalContext();
    const { isMobileUserAgent } = useIsMobile();
    const isUserLoggedIn = useIsUserLoggedIn();
    const isUserLoggedInLoading = useIsUserLoggedInLoading();
    const openVisitorLoginImageUpsell = useCallback(({ title, description, origin, image, imageAlt, closeCallback, disallowClose, }) => {
        if (!enabled || isUserLoggedIn || isUserLoggedInLoading) {
            return;
        }
        if (import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD) {
            window.open(sanitizeUrl('/auth/signin'), '_blank');
            return;
        }
        openModal(LoginModal, {
            pitchMessage: title ? { title, description } : undefined,
            origin,
            experimentalImageDesign: {
                image,
                imageAlt,
            },
            closeCallback,
            disallowClose,
        }, { replace: true });
    }, [enabled, openModal, isUserLoggedIn, isUserLoggedInLoading]);
    const openVisitorLoginUpsell = useCallback(({ title, description, origin, sheetModalVariant, closeCallback, overrideRedirectUrl, disallowedMethods, overrideMobileVariant = false, disallowClose, renderCloseButton, }) => {
        if (!enabled || isUserLoggedIn || isUserLoggedInLoading) {
            return;
        }
        if (import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD) {
            window.open(sanitizeUrl('/auth/signin'), '_blank');
            return;
        }
        let sheetModalDesign = 'full-sheet';
        if ((overrideMobileVariant || !isMobileUserAgent) && sheetModalVariant) {
            sheetModalDesign = sheetModalVariant;
        }
        openModal(LoginModal, {
            pitchMessage: title ? { title, description } : undefined,
            origin,
            sheetModalDesign,
            closeCallback,
            overrideRedirectUrl,
            disallowedMethods,
            disallowClose,
            renderCloseButton,
        }, { replace: true });
    }, [enabled, isMobileUserAgent, openModal, isUserLoggedIn, isUserLoggedInLoading]);
    return useMemo(() => ({
        openVisitorLoginUpsell,
        openVisitorLoginImageUpsell,
    }), [openVisitorLoginImageUpsell, openVisitorLoginUpsell]);
};
//# sourceMappingURL=useBrandedVisitorGate.js.map